import React from 'react'

interface Props {
  features: {
    isEnabled: (flag: string) => boolean
  }
}

export const FeaturesContext = React.createContext<
  Props['features'] | undefined
>(undefined)

export const FeaturesProvider: React.FC<Props> = (props) => {
  return (
    <FeaturesContext.Provider value={props.features}>
      {props.children}
    </FeaturesContext.Provider>
  )
}
